import { Route, Routes } from "react-router-dom";
import { Dashboard } from "../pages/dashboard/Dashboard";
import ChangePassword from "../pages/login/changePassword";
import Login from "../pages/login/login";
import { FeatureAccess } from "../pages/userMangement/featureAccess/featureAccess";
import { FeatureAccessAddEdit } from "../pages/userMangement/featureAccess/featureAccess.addEdit";
import { Features } from "../pages/userMangement/features/features";
import { FeaturesAddEdit } from "../pages/userMangement/features/features.AddEdit";
import { MenuUser } from "../pages/userMangement/menu/menu";
import { MenuAddEdit } from "../pages/userMangement/menu/menu.menuAddEdit";
import { MenuGroup } from "../pages/userMangement/menuGroup/menuGroup";
import { MenuGroupAddEdit } from "../pages/userMangement/menuGroup/menuGroup.addEdit";
import { Modules } from "../pages/userMangement/modules/modules";
import { ModulesAddEdit } from "../pages/userMangement/modules/modules.addEdit";
import { Role } from "../pages/userMangement/role/role";
import { RoleAddEdit } from "../pages/userMangement/role/role.roleAddEdit";
import { User } from "../pages/userMangement/user/user";
import { UserDetails } from "../pages/userMangement/user/user.addEdit";
import PrivateOutlet from "./privateRoute";

function Routing() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route path="/" element={<PrivateOutlet />}>
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/dashboard" element={<Dashboard />} />

        {/* usermangent */}
        <Route path="/user" element={<User />} />
        <Route path="/user/details/:id?" element={<UserDetails />} />

        {/* Role */}
        <Route path="/role" element={<Role />} />
        <Route path="/role/details/:id?" element={<RoleAddEdit />} />

        {/* Modules */}
        <Route path="/modules" element={<Modules />} />
        <Route path="/modules/details/:id?" element={<ModulesAddEdit />} />

        {/* Menu */}
        <Route path="/menu" element={<MenuUser />} />
        <Route path="/menu/details/:id?" element={<MenuAddEdit />} />

        {/* Feature */}
        <Route path="/feature" element={<Features />} />
        <Route path="/feature/details/:id?" element={<FeaturesAddEdit />} />

        {/* Feature Access */}
        <Route path="/featureAccess" element={<FeatureAccess />} />
        <Route path="/featureAccess/details/:id?" element={<FeatureAccessAddEdit />} />

        {/* Menu Group */}
        <Route path="/menuGroup" element={<MenuGroup />} />
        <Route path="/menuGroup/details/:id?" element={<MenuGroupAddEdit />} />
      </Route>
    </Routes>
  );
}

export default Routing;
